<template>
  <div class="material-tags-container">
    <el-card>
      <app-filter :filter-list="table_filter" @search="onSearch" />
    </el-card>
    <el-card class="mt-20">
      <div class="table-toolbar-wrapper">
        <el-button size="mini" type="primary" icon="el-icon-plus" @click="openLabelDialog">新增标签</el-button>
      </div>
      <app-table ref="tags-table" :table-key="table_config.table_key" :table-props="table_config.table_props" :tablep="table_config.table_params" :get-data="table_config.get_data" />
    </el-card>
    <!-- 新增标签弹窗 -->
    <el-dialog v-bind="dialog_config.props" :visible.sync="dialog_config.is_show">
      <app-form v-if="dialog_config.is_show" :form-data="dialog_config.form_config" @confirm="onAddMaterialLabel" @cancel="dialog_config.is_show = false" />
    </el-dialog>
  </div>
</template>

<script>
import AdvertisingResource from '@/api/advertising';
const advertisingResource = new AdvertisingResource();
import { getMaterialLabelApi, addMaterialLabelApi, editMaterialLabelApi, deleteMaterialLabelApi } from '@/api/material/label';
import { isEmpty } from '@/utils/is';

export default {
  components: {
    'app-table': () => import('@/components/app-table'),
    'app-filter': () => import('@/components/app-filter'),
    'app-form': () => import('@/components/app-form'),
  },
  data() {
    return {
      /** 过滤项配置 */
      table_filter: require('./model/table-filter.js')(this),
      /** 表格配置 */
      table_config: {
        /** 表格属性 */
        table_props: { stripe: true },
        /** 请求参数 */
        table_params: { page: 1, limit: 10 },
        /** 表格头配置 */
        table_key: require('./model/table-key.js')(this),
        /** 获取表格数据 */
        get_data: this.getMaterialLabel,
      },
      /** 弹窗配置 */
      dialog_config: {
        is_show: false,
        props: {
          title: '新增标签',
          width: '800px',
        },
        form_config: require('./model/form-config.js')(this),
      },
    };
  },
  mounted() {
    this.setGameData();
  },
  methods: {
    /** 获取游戏列表 */
    getGameList: function(params) {
      return new Promise((resolve, reject) => {
        advertisingResource.getGameListApi(params).then(resolve).catch(reject);
      });
    },
    /** 获取表格数据 */
    getMaterialLabel(params) {
      return new Promise((resolve, reject) => {
        getMaterialLabelApi(params).then(resolve).catch(reject);
      });
    },
    /** 设置游戏数据 */
    setGameData() {
      this.getGameList({ refresh: 1, is_parent: 1 }).then((res) => {
        for (let i = 0; i < res.list.length; i++) {
          res.list[i]['disabled'] = true;
        }
        this.table_filter.parent_game_ids.props.options = res.list;
        this.dialog_config.form_config.parent_game_id.props.options = res.list;
      });
    },
    /** 搜索 */
    onSearch(params) {
      const { parent_game_ids } = params || {};
      Object.assign(this.table_config.table_params, { ...params, ...(parent_game_ids && { parent_game_ids: [parent_game_ids] }) });
      this.seekTable();
    },
    /** 表格搜索 */
    seekTable() {
      this.$refs['tags-table'].seekTable();
    },
    /** 刷新表格 */
    refreshTable() {
      this.$refs['tags-table'].refer();
    },
    /** 打开新增标签弹窗 */
    openLabelDialog() {
      Object.assign(this.dialog_config, { form_config: require('./model/form-config.js')(this) });
      this.dialog_config.form_config.parent_game_id.props.options = this.table_filter.parent_game_ids.props.options;
      this.dialog_config.is_show = true;
    },
    /** 新增标签 */
    onAddMaterialLabel(params) {
      const data = { ...params, labels: params.labels?.split('、')?.slice(0, 20) || [] };
      addMaterialLabelApi(data).then(() => {
        this.$message.success('新增成功!');
        this.seekTable();
        this.dialog_config.is_show = false;
      });
    },
    /** 删除标签 */
    onDeleteMaterialLabel(row) {
      const { id, label } = row;
      this.$confirm(`此操作将删除「${label}」标签, 是否继续？`, '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$set(row, 'loading', true);
        deleteMaterialLabelApi(id).then(() => {
          this.$message.success('删除成功！');
          this.seekTable();
        }).finally(() => {
          this.$set(row, 'loading', false);
        });
      });
    },
    /** 编辑标签 */
    onEditMaterialLabel(row) {
      const { id, label, level } = row;
      const { message } = this.dialog_config.form_config.labels.rules.at(0);
      const { maxLength, getMessage } = this.dialog_config.form_config.labels.rules.at(2);
      if (isEmpty(label) || label.length > maxLength) {
        this.$message.warning(isEmpty(label) ? message : getMessage(maxLength));
        return;
      }
      if (!level) {
        this.$message.warning('请选择标签等级');
        return;
      }
      this.$set(row, 'loading', true);
      editMaterialLabelApi(id, { label, level }).then(() => {
        this.$message.success('编辑成功！');
        this.refreshTable();
      }).finally(() => {
        this.$set(row, 'loading', false);
      });
    },
  },
};
</script>
